// extracted by mini-css-extract-plugin
export default {"OfferCollapse":"OfferCollapse_OfferCollapse__Zzj5+","CollapsePanel":"OfferCollapse_CollapsePanel__eK7IV"};